/* DOMNO. portal — honest order statuses + native back-scroll (9 Sep 2026)

   1. STATUS WAS LYING. D86233 read "Shipped" on the card and "Being packed" on tracking. Both came
      from Shopify's fulfillment_status, which only says a fulfilment RECORD exists — not that the
      parcel has gone. The warehouse can mark an order fulfilled before a carrier label is bought,
      so fulfilled + no tracking is NOT shipped. Honest reading needs both fields:
        fulfilled + tracking number -> Shipped
        fulfilled + no tracking     -> Packed
        partial                     -> Part shipped
        otherwise                   -> Processing
      Rewrites the pill on the order CARD and on the DETAIL screen, since Charlie's Liquid renders
      the card straight from fulfillment_status and the two would otherwise disagree on screen.

   2. BACK SHOULD RETURN YOU TO WHERE YOU WERE (Dom: "pretty native for most websites"). The
      earlier fix over-corrected: a MENU switch should go to the top, but BACK should restore the
      position you left. Small stack, restored on back only, cleared on any menu jump. */
(function(){
  function scroller(){ return document.getElementById('domno-portal'); }

  function statusOf(o){
    if (!o) return null;
    var t = (o.tracking || [])[0];
    var hasTrack = !!(t && (t.number || t.url));
    if (o.status === 'fulfilled') return hasTrack
      ? { cls:'delivered', label:'Shipped' }
      : { cls:'transit',   label:'Packed' };
    if (o.status === 'partial') return { cls:'transit', label:'Part shipped' };
    return { cls:'proc', label:'Processing' };
  }
  window.dpStatusOf = statusOf;

  function fixPills(){
    var orders = window.DP_ORDERS || [];
    if (!orders.length) return;
    /* #p-orderdetail included so the detail header agrees with the card it came from */
    var hosts = document.querySelectorAll('#p-orders .card, #p-home .card, #p-orderdetail');
    for (var i=0;i<hosts.length;i++){
      var nEl = hosts[i].querySelector('.n'); if (!nEl) continue;
      var nm = (nEl.textContent||'').trim();
      var o = null;
      for (var k=0;k<orders.length;k++) if (orders[k].name === nm) { o = orders[k]; break; }
      if (!o) continue;
      var s = statusOf(o); if (!s) continue;
      var stat = hosts[i].querySelector('.stat'); if (!stat) continue;
      if (stat.getAttribute('data-dp-status') === s.label) continue;
      stat.setAttribute('data-dp-status', s.label);
      stat.innerHTML = '<span class="ind ' + s.cls + '"></span>' + s.label;
    }
  }

  var stack = [];
  function pushPos(){
    var el = scroller();
    stack.push(el ? el.scrollTop : 0);
    if (stack.length > 20) stack.shift();
  }
  function popPos(){
    var el = scroller(); if (!el) return;
    var y = stack.length ? stack.pop() : 0;
    /* twice: once after the panel swap, once after it has painted and has height to scroll into */
    setTimeout(function(){ try{ el.scrollTop = y; }catch(e){} }, 30);
    setTimeout(function(){ try{ el.scrollTop = y; }catch(e){} }, 140);
  }

  /* ⚠ THE DRAWER IS THE SCROLLER, NOT THE WINDOW. Dom, 10 Sep: "sometimes the sidebar glitches and
     shows from a few scrolls down, and you can't go back up unless you refresh."
     domno-portal.js's show() ends with window.scrollTo(0,0) — which scrolls the PAGE behind the
     overlay, an element that is `overflow:hidden` while the drawer is open, so it does nothing at
     all. #domno-portal keeps whatever scrollTop it had. Scroll down through Orders, jump to
     Rewards, and the shorter panel opens already scrolled past its own top with nothing above to
     scroll back into. Every panel jump and every fresh open now puts the drawer itself back to 0.
     Twice, because the credits box, the ladder and the images all land after the swap and change
     the height under you. */
  function toTop(){
    var el = scroller(); if (!el) return;
    var z = function(){ try{ el.scrollTop = 0; }catch(e){} };
    z(); setTimeout(z, 30); setTimeout(z, 160);
  }

  /* every opener has to be covered and they are scattered — the header icon's inline onclick,
     claim.js after sign-in, domno-portal.js on the way back from Shopify's login. Watching the
     class is the one place that catches all of them. */
  function watchOpen(){
    var ov = document.getElementById('dp-overlay');
    if (!ov || ov.getAttribute('data-dp-scrollwatch')) return;
    ov.setAttribute('data-dp-scrollwatch','1');
    var was = ov.classList.contains('open');
    try{
      new MutationObserver(function(){
        var now = ov.classList.contains('open');
        if (now && !was){ stack.length = 0; toTop(); }
        was = now;
      }).observe(ov, { attributes:true, attributeFilter:['class'] });
    }catch(e){}
  }

  function install(){
    if (typeof window.dpGo !== 'function' || typeof window.dpBack !== 'function') return false;
    var body = document.querySelector('#domno-portal .body');
    if (!body) return false;
    if (body.getAttribute('data-dp-status-wired')) return true;
    body.setAttribute('data-dp-status-wired','1');

    fixPills();
    watchOpen();

    document.addEventListener('click', function(e){
      var t = e.target && e.target.closest ? e.target.closest('[data-dp-track-btn],[data-dp-track]') : null;
      if (t) pushPos();
      setTimeout(fixPills, 200);
    }, true);

    var origBack = window.dpBack;
    window.dpBack = function(){
      var r; try{ r = origBack.apply(this, arguments); }catch(e){}
      popPos(); setTimeout(fixPills, 60);
      return r;
    };

    var origGo = window.dpGo;
    window.dpGo = function(){
      var r; try{ r = origGo.apply(this, arguments); }catch(e){}
      stack.length = 0;                 /* a menu jump is a fresh start, not a step back */
      toTop();                          /* ...and a fresh start begins at the top */
      setTimeout(fixPills, 60);
      return r;
    };

    return true;
  }

  if (!install()){
    var n=0, iv=setInterval(function(){ n++; if (install() || n>100) clearInterval(iv); }, 100);
  }
})();
